import {Component, computed, inject, Input, OnInit} from '@angular/core';
import {IndexIoService} from '../../../services/index-io.service';
import {NgForOf, NgIf} from '@angular/common';
import {DocumentsDTO} from '../../../models/dto/document-dto';
import { HttpClient } from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {toObservable, ToObservableOptions} from '@angular/core/rxjs-interop';
import { STATIC_DISCLAIMER } from './static-disclaimer';

@Component({
  selector: 'bnpp-indx-index-footer',
  imports: [
    NgIf,
    NgForOf
  ],
  templateUrl: './index-footer.component.html',
  styleUrl: './index-footer.component.scss',
  standalone:true
})
export class IndexFooterComponent implements OnInit {
  public todayFormatted: string = '';

  constructor(private http: HttpClient, private readonly sanitizer: DomSanitizer ) {

  }

  private setToday(): void {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0'); // months are 0‑based
    const dd = String(now.getDate()).padStart(2, '0');
    this.todayFormatted = `${yyyy}/${mm}/${dd}`;
  }

  private indexInfoService = inject(IndexIoService);
  public deployUrlHost = this.indexInfoService.getDeployUrlHost();
  @Input() mdsCode:string= '';
  indexKeyInfo = this.indexInfoService.indexKeyInfo;
  indexDocumentInfo = this.indexInfoService.indexDocumentsInfo;

  private readonly dynamic$ = toObservable(this.indexKeyInfo, { requireSync: true } as ToObservableOptions );


  fullDisclaimer = computed(()=>{
    const disclaimerText = this.indexKeyInfo();
    return this.sanitizer.bypassSecurityTrustHtml(STATIC_DISCLAIMER+disclaimerText?.disclaimer)
  })




  ngOnInit(): void {
    this.setToday();
    this.indexInfoService.getIndexKeyInfo(this.mdsCode);
    this.indexInfoService.getIndexDocuments(this.mdsCode);
  }

  isValueNameBnpParibas(value: string | undefined): boolean {
    return !!value && value.trim() === 'BNP Paribas';
  }


  onDownloadDocument(item: DocumentsDTO) {
    this.indexInfoService.downloadDocument("Document",item.Path,item.Title,item.FileExtension,item.S3Key).subscribe();
  }


}
